import React from "react";
import ComicBase from "../ComicBase";

export default function ComicNaruto() {
  return (
    <ComicBase
      titulo="TOUCHUUKASOU parte 3"
      portada="https://fullcomics18.org/img6/touchuukasou3-1.jpg"
    paginas={[
  "https://fullcomics18.org/img6/touchuukasou3-1.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-2.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-3.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-4.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-5.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-6.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-7.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-8.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-9.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-10.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-11.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-12.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-13.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-14.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-15.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-16.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-17.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-18.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-19.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-20.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-21.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-22.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-23.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-24.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-25.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-26.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-27.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-28.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-29.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-30.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-31.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-32.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-33.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-34.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-35.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-36.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-37.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-38.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-39.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-40.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-41.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-42.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-43.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-44.jpg",
  "https://fullcomics18.org/img6/touchuukasou3-45.jpg"
]}
      sugeridos={[]}


      info={{
      grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Ball Sucking", "BBW", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Bikini", "Digital", "Double Blowjob", "Freckles", "Group", "Huge Breasts", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Shaved Head", "Sole Female", "Sweating", "Swimsuit"],
    artistas: "Fuetakishi",
      }}
    />
  );
}

export const infoManga = {
  titulo: "TOUCHUUKASOU parte 3",
  portada: "https://fullcomics18.org/img6/touchuukasou3-1.jpg",
  reverso: "https://fullcomics18.org/img6/touchuukasou3-21.jpg",
   fecha:"2026-05-17",


  info: {
    grupo: "shoot the moon",
    tipo: "doujinshi",
    idioma: "Español",
    serie: "original",
    personajes: [" "],
etiquetas: ["Ahegao", "Ball Sucking", "BBW", "Big Areolae", "Big Ass", "Big Breasts", "Big Nipples", "Big Penis", "Bikini", "Digital", "Double Blowjob", "Freckles", "Group", "Huge Breasts", "Mind Break", "Multi-work Series", "Nakadashi", "Netorare", "Shaved Head", "Sole Female", "Sweating", "Swimsuit"],
    artistas: "Fuetakishi",
  },
};
